// Load all the controllers within this directory and all subdirectories. 
// Controller files must be named *_controller.js.

import { Application } from "@hotwired/stimulus"
import { registerControllers } from 'stimulus-vite-helpers'
import Carousel from '@stimulus-components/carousel'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

const application = Application.start()
application.register('carousel', Carousel)

const controllers = import.meta.glob('./*_controller.js', { eager: true })
registerControllers(application, controllers)
